"use strict";

(function(datepicker, locale){
    var locale = Fotobook.config.data.regional.language,
        firstDayOfWeek = Fotobook.config.data[Fotobook.Settings.REGIONAL_FIRST_DAY_OF_WEEK];
    datepicker.regional[locale] = {
        "closeText": t("photobook-js-dialog-buttonOk"),
//        "prevText": "&#x3C;",
//        "nextText": "&#x3E;",
        "currentText": t("photobook-js-today"),
        "monthNames": [
           t("photobook-js-month-full-january"),
           t("photobook-js-month-full-february"),
           t("photobook-js-month-full-march"),
           t("photobook-js-month-full-april"),
           t("photobook-js-month-full-may"),
           t("photobook-js-month-full-june"),
           t("photobook-js-month-full-july"),
           t("photobook-js-month-full-august"),
           t("photobook-js-month-full-september"),
           t("photobook-js-month-full-october"),
           t("photobook-js-month-full-november"),
           t("photobook-js-month-full-december"),
        ],
        "monthNamesShort": [
           t("photobook-js-month-short-january"),
           t("photobook-js-month-short-february"),
           t("photobook-js-month-short-march"),
           t("photobook-js-month-short-april"),
           t("photobook-js-month-short-may"),
           t("photobook-js-month-short-june"),
           t("photobook-js-month-short-july"),
           t("photobook-js-month-short-august"),
           t("photobook-js-month-short-september"),
           t("photobook-js-month-short-october"),
           t("photobook-js-month-short-november"),
           t("photobook-js-month-short-december"),
        ],
        "dayNames": [
            t("photobook-js-day-full-sunday"),
            t("photobook-js-day-full-monday"),
            t("photobook-js-day-full-tuesday"),
            t("photobook-js-day-full-wednesday"),
            t("photobook-js-day-full-thursday"),
            t("photobook-js-day-full-friday"),
            t("photobook-js-day-full-saturday"),
         ],
        "dayNamesShort": [
            t("photobook-js-day-short-sunday"),
            t("photobook-js-day-short-monday"),
            t("photobook-js-day-short-tuesday"),
            t("photobook-js-day-short-wednesday"),
            t("photobook-js-day-short-thursday"),
            t("photobook-js-day-short-friday"),
            t("photobook-js-day-short-saturday"),
         ],
        "dayNamesMin": [
            t("photobook-js-day-narrow-sunday"),
            t("photobook-js-day-narrow-monday"),
            t("photobook-js-day-narrow-tuesday"),
            t("photobook-js-day-narrow-wednesday"),
            t("photobook-js-day-narrow-thursday"),
            t("photobook-js-day-narrow-friday"),
            t("photobook-js-day-narrow-saturday"),
        ],
//        "weekHeader": "Нед",
        "dateFormat": t("photobook-js-datepicker-dateFormat"),
        "firstDay": firstDayOfWeek,
//        "isRTL": false,
//        "showMonthAfterYear": false,
//        "yearSuffix": "",
     };
     datepicker.setDefaults(datepicker.regional[locale]);
})($.datepicker);
